module.exports = __webpack_public_path__ + "static/media/Java.1a308e98.png";